<template>
  <v-card class="add-discount-code" height="90vh">
    <v-card-title>{{ $t('admin_acc_discount_code.add_title') }}</v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-form ref="form">
          <v-text-field outlined
                        :label="$t('admin_acc_discount_code.code')"
                        v-model="discountCode.code"
                        :rules="requiredRules"></v-text-field>
          <v-row>
            <v-col class="pb-0">
              <DatePickerInput :label="$t('admin_acc_discount_code.start')"
                               v-model="discountCode.start"
                               :rules="requiredRules"></DatePickerInput>
            </v-col>
            <v-col class="pb-0">
              <DatePickerInput :label="$t('admin_acc_discount_code.end')"
                               v-model="discountCode.end"
                               :rules="requiredRules"></DatePickerInput>
            </v-col>
          </v-row>
          <v-select outlined
                    :items="discountCodeTypeOptions"
                    :label="$t('admin_acc_discount_code.type')"
                    v-model="discountCode.type"
                    :rules="requiredRules"></v-select>
          <v-select outlined
                    v-if="discountCode.type === 'FACILITY'"
                    :label="$t('admin_acc_discount_code.item_type')"
                    :items="facilityTypeOptions"
                    v-model="discountCode.item_type_id"
                    :rules="requiredRules"></v-select>
          <v-select outlined
                    v-if="discountCode.type === 'GYM_PASS'"
                    :label="$t('admin_acc_discount_code.gym_pass_type')"
                    :items="subscriptionTypeOptions"
                    v-model="discountCode.gym_pass_type_id"
                    :rules="requiredRules"></v-select>
          <v-text-field outlined
                        v-if="discountCode.type === 'FACILITY'"
                        :label="$t('admin_acc_discount_code.minimum_amount')"
                        prefix="$"
                        type="number"
                        step="1"
                        min="0"
                        v-model="discountCode.minimum_amount"></v-text-field>
          <v-text-field outlined
                        :label="discountByValue ? $t('admin_acc_discount_code.discount_value') : $t('admin_acc_discount_code.discount_percentage')"
                        :prefix="discountByValue ? '$': '%'"
                        type="number"
                        step="1"
                        min="0"
                        v-model="discount">
            <template #append>
              <v-tooltip bottom>
                <template #activator="{on, attrs}">
                  <v-icon v-on="on"
                          v-bind="attrs"
                          @click="discountByValue = !discountByValue">
                    mdi-swap-horizontal
                  </v-icon>
                </template>
                <span>{{ $t('admin_acc_discount_code.change_discount_type') }}</span>
              </v-tooltip>
            </template>
          </v-text-field>
          <v-text-field outlined
                        :readonly="infiniteQuota"
                        :label="$t('admin_acc_discount_code.quota')"
                        :type="infiniteQuota ? 'text' : 'number'"
                        step="1"
                        min="1"
                        :append-icon="infiniteQuota ? 'mdi-numeric': 'mdi-infinity'"
                        @click:append="infiniteQuota = !infiniteQuota"
                        v-model="infiniteQuota ? $t('admin_acc_discount_code.infinite') : discountCode.quota">
          </v-text-field>
          <v-text-field outlined
                        :readonly="infiniteUsePerAccount"
                        :label="$t('admin_acc_discount_code.use_per_account')"
                        :type="infiniteUsePerAccount ? 'text' : 'number'"
                        step="1"
                        min="1"
                        :append-icon="infiniteUsePerAccount ? 'mdi-numeric': 'mdi-infinity'"
                        @click:append="infiniteUsePerAccount = !infiniteUsePerAccount"
                        v-model="infiniteUsePerAccount ? $t('admin_acc_discount_code.infinite') : discountCode.use_per_account">
          </v-text-field>

        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit')">
        {{ $t('close') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && submit()">
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {computed, onMounted, ref} from "@vue/composition-api";
import DatePickerInput from "@/components/DatePickerInput.vue";

export default {
  name: 'AddDiscountCodeModal',
  components: {DatePickerInput},
  props: {
    bookingRecordId: String,
  },
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const discountCode = ref({
      minimum_amount: 0,
      quota: 1,
      use_per_account: 1,
    });
    const discount = ref(0);
    const discountByValue = ref(true);
    const discountCodeTypeOptions = ref([
      {text: root.$t('admin_acc_discount_code.type_FACILITY'), value: 'FACILITY'},
      {text: root.$t('admin_acc_discount_code.type_GYM_PASS'), value: 'GYM_PASS'},
      {text: root.$t('admin_acc_discount_code.type_MEMBERSHIP'), value: 'MEMBERSHIP'},
    ]);
    const infiniteQuota = ref(false);
    const infiniteUsePerAccount = ref(false);

    // FACILITY
    const facilityTypes = ref([]);
    const facilityTypeOptions = computed(() => {
      return facilityTypes.value.map((t) => {
        return {text: t.name, value: t.id}
      })
    });
    const getFacilityTypes = function () {
      root.$callAPI('room/item_type/', {}, function (response) {
        facilityTypes.value = _.filter(response.body.item_types, 'open_for_booking');
      });
    }

    // GYM_PASS
    const subscriptionTypes = ref([]);
    const subscriptionTypeOptions = computed(() => {
      return subscriptionTypes.value.map((t) => {
        return {text: t.name, value: t.id};
      })
    })
    const getSubscriptionTypes = function () {
      root.$callAPI('aafb/gym_subscription/types/', {}, function (response) {
        subscriptionTypes.value = _.sortBy(response.body.subscription_types, 'price');
      });
    }


    const submit = function () {
      root.$callAPI('aafb/admin/discount_code/create/', {
        ...discountCode.value,
        discount_value: discountByValue.value ? discount.value : null,
        discount_percentage: discountByValue.value ? null : discount.value,
        quota: infiniteQuota.value ? -1 : discount.value.quota,
        use_per_account: infiniteUsePerAccount.value ? -1 : discountCode.value.use_per_account,
      }, function (response) {
        emit('submit', true);
      })
    }

    onMounted(() => {
      getFacilityTypes();
      getSubscriptionTypes();
    })

    return {
      requiredRules,
      discountCode,
      discount,
      discountByValue,
      infiniteQuota,
      infiniteUsePerAccount,
      discountCodeTypeOptions,
      facilityTypeOptions,
      subscriptionTypeOptions,
      submit
    }
  }
}
</script>

<style lang="less">
.add-discount-code {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .v-card__title, .v-card__text, .v-card__actions {
    width: 100%;
  }

  .v-card__title, .v-card__actions {
    flex: 0 0 auto;
  }

  .v-card__text {
    flex: 1 1 0;
    overflow: auto;
  }
}


</style>
